import axios from 'axios';
import api_url from '../urls';
const actions = {

    addGradeCurricular (context, value) {
        context.commit('PRELOADER_MUDAR',true)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.post(api_url.api_admin + 'v1/admin/grade-curricular',
        {
          curso_id: value.curso.id,
          tipo_curso_id: value.tipo_curso.id,
          carga_horaria: value.carga_horaria,
          info_pagamento: value.info_pagamento,
          info_periodo: value.info_periodo,
          url_video: value.url_video,
          info_justificativa: value.info_justificativa,
          info_objetivo: value.info_objetivo,
          info_publico: value.info_publico,
          empresa_id: 1,
          status: 1
        }
        , {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
             //console.log(response);
             

        })
        .catch((error) => {
            console.log(error);
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
        // console.log(curso)
    },
    async editarGradeCurricular (context, value) {
        
        context.commit('PRELOADER_MUDAR',true)
        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
      await   axios.post(api_url.api_admin + 'v1/admin/edit-grade-curricular/' + value.id,
        {
          carga_horaria: value.carga_horaria,
          info_pagamento: value.info_pagamento,
          info_periodo: value.info_periodo,
          url_video: value.url_video,
          info_justificativa: value.info_justificativa,
          info_objetivo: value.info_objetivo,
          info_publico: value.info_publico,
          info_justificativa_pt: value.info_justificativa_pt,
          info_objetivo_pt: value.info_objetivo_pt,
          info_publico_pt: value.info_publico_pt,
     
        }
        , {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
             //console.log(response);
             

        })
        .catch((error) => {
            console.log(error);
        }).finally(()=> context.commit('PRELOADER_MUDAR',false))
        // console.log(curso)
    },
    setGradeCurricular(context,value){
        context.commit('SET_GRADE_CURRICULLAR', value)
    },

    allGradeCurricular (context,value) {

      const USER_TOKEN = localStorage.getItem('access_token');
      const AuthStr = 'Bearer '.concat(USER_TOKEN)
       axios.get(api_url.api_admin + 'v1/admin/get_grades',
       {
          headers: {
              'authorization': AuthStr,
              'Accept' : 'application/json',
              'Content-Type': 'application/json'
          }
      })
      .then(response => {
           //console.log(response.data);
          context.commit('ALL_GRADE_CURRICULLAR', response.data)
      })
      .catch((error) => {
          console.log(error);
      });
      
    },

  async  getGradeCurricular (context,value) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
      await   axios.get(api_url.api_admin + 'v1/admin/getjoingrade/' + value,
         {
            headers: {
                'authorization': AuthStr,
                'Accept' : 'application/json',
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            console.log(response.data[0]);
            context.commit('SET_GRADE_CURRICULLAR', response.data[0])
        })
        .catch((error) => {
            console.log(error);
        });
        
      },

    setGradeCurricular(context,value){
        context.commit('SET_GRADE_CURRICULLAR', value)
    },

    setarGradeCurricular(context,value){
        context.commit('SETAR_GRADE_CURRICULLAR', value)
    },

    addOfertaGradeDisciplina (context, value) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.post(api_url.api_admin + 'v1/admin/grade-curricular-ofeta',
        {
          grade_curricular_id: value.grade_id,
          disciplina_id: value.disciplina.id,
          tipo_disciplina_id: value.tipo_disciplina.id,
          carga_horaria: value.carga_horaria,
          empresa_id: 1,
          status: 1
        }
        , {
            headers: {
                'Authorization': AuthStr,
                'Content-Type': 'application/json',
                'X-Requested-With':'XMLHttpRequest',
            }
        })
        .then(response => {
             //console.log(response);
        })
        .catch((error) => {
            console.log(error);
        });
       // console.log(value)
    },
    allOfertaGradeCurricular (context,value) {

        const USER_TOKEN = localStorage.getItem('access_token');
        const AuthStr = 'Bearer '.concat(USER_TOKEN)
         axios.get(api_url.api_admin + 'v1/admin/grade-curricular-ofeta/'+value.id,
         {
            headers: {
                'authorization': AuthStr,
                'Accept' : 'application/json',
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
             //console.log(response.data);
            context.commit('ALL_OFERTA_GRADE_CURRICULLAR', response.data)
        })
        .catch((error) => {
            console.log(error);
        });
        
      },

}

export default actions